







import { Component, Vue } from 'vue-property-decorator';
import OrderList from '@/components/Invoicing/Order/OrderList.vue';

@Component({
  components: {
    OrderList,
  },
})
export default class Orders extends Vue {

}
